import styled from '@emotion/styled';
import { color } from 'styled-system';

import Flex from 'shopper/components/Flex';

const CategoriesDropdownItem = styled(Flex)`
  cursor: pointer;
  justify-content: space-between;

  ${color};
`;

export default CategoriesDropdownItem;
